import { PostHogService } from '@cosmos/angular/utils';

/**
 * App-initializer factory for PostHog. Must run BEFORE the auth initializer so
 * that `AuthService.updateCurrentUser()` can identify the user against a live
 * PostHog client on startup (otherwise identify/capture silently no-op).
 *
 * User identification is owned by `AuthService` (login + startup + reset on
 * logout) — this helper only boots the SDK. Add future PostHog bootstrap config
 * here.
 */
export function initPostHog(postHogService: PostHogService) {
  return () => {
    postHogService.initialize('f-user');

    console.log('PostHog initialized for f-user app');

    postHogService.capture('app_initialized');
  };
}
